import { Trans } from '@lingui/react/macro';
import { AppError } from 'shared/domains/errors';
export default function SignedOut() {
    return (<AppError code={400} title={<Trans>Signed out</Trans>} message={<Trans>You have been signed out. Please sign in again.</Trans>}/>);
}
